<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Tooltip" });
import "tailwindcss/tailwind.css";
export let color = "light";
export let position = "north";
export let size = "sm";
export let isVisible = true;
export let css = "";
$: classes = `s8-tooltip s8-${color} s8-${size} ${css}`;
</script>

{#if isVisible }
    <div data-position = { position } class = { classes }>
        <slot>Hello World</slot>
    </div>
{/if}

<style>

    div.s8-tooltip {

        position: absolute;

        z-index: 10;

        border-radius: 0.25rem;

        padding-left: 0.5rem;

        padding-right: 0.5rem;

        padding-top: 0.25rem;

        padding-bottom: 0.25rem;

        font-size: 0.625rem;

        line-height: 1.375;

        transition-property: opacity;

        transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

        transition-duration: 150ms;
}

        div.s8-tooltip.s8-lg {

        padding: 1rem;

        font-size: 0.75rem;

        line-height: 1rem;
}

        div.s8-tooltip {

        --offset: 12px;
}

        div.s8-tooltip:after {

        position: absolute;

        border-style: solid;
            content: ' ';
}

        /* Positions & Arrows --------------------------------------- */

        /* north, north-east, north-west */

        div.s8-tooltip[data-position^='north'] {
            /* move anything starting with north to the top (above parent) */
            bottom: calc(100% + 5px);
        }

        div.s8-tooltip[data-position^='north']:after {

        border-bottom-width: 0px;

        border-left-color: transparent !important;

        border-right-color: transparent !important;

        border-bottom-color: transparent !important;
}

        /* south, south-east, south-west */

        div.s8-tooltip[data-position^='south'] {
            /* move anything starting with south to the bottom (below parent) */
            top: calc(100% + 5px);
        }

        div.s8-tooltip[data-position^='south']:after {

        border-top-width: 0px;

        border-top-color: transparent !important;

        border-left-color: transparent !important;

        border-right-color: transparent !important;
}

        /* west, west-north, west-south */

        div.s8-tooltip[data-position^='west'] {
            /* move anything starting with west to the left */
            right: calc(100% + 5px);
        }

        div.s8-tooltip[data-position^='west']:after {

        border-right-width: 0px;

        border-top-color: transparent !important;

        border-right-color: transparent !important;

        border-bottom-color: transparent !important;
}

        /* east, east-north, east-south */

        div.s8-tooltip[data-position^='east'] {
            /* move anything starting with east to the right */
            left: calc(100% + 5px);
        }

        div.s8-tooltip[data-position^='east']:after {

        border-left-width: 0px;

        border-top-color: transparent !important;

        border-left-color: transparent !important;

        border-bottom-color: transparent !important;
}

        /* north & south */

        div.s8-tooltip[data-position='north'],
        div.s8-tooltip[data-position='south'] {
            left: calc(50% - 15px); /* move north and south to the middle (horizontally) */
            transform: translateX(-50%);
        }

        div.s8-tooltip[data-position='north']:after, div.s8-tooltip[data-position='south']:after {
                left: calc(50% + 2px);
                transform: translateX(-50%);
            }

        /* east & west */

        div.s8-tooltip[data-position='west'],
        div.s8-tooltip[data-position='east'] {
            top: 50%; /* move east and west to the middle (vertically) */
            transform: translateY(-50%);
        }

        div.s8-tooltip[data-position='west']:after, div.s8-tooltip[data-position='east']:after {
                top: calc(50% - 5px);
            }

        /* east-south & west-south */

        div.s8-tooltip[data-position$='-south'] {
            bottom: 0px;
        }

        /* move anything ending with south to the bottom */

        div.s8-tooltip[data-position$='-south']:after {
                bottom: var(--offset);
            }

        /* north-west & south-west */

        div.s8-tooltip[data-position$='-west'] {
            right: 0px;
        }

        /* move anything ending with west to the right */

        div.s8-tooltip[data-position$='-west']:after {
                right: var(--offset);
            }

        /* north-east & south-east */

        div.s8-tooltip[data-position$='-east']:after {
                left: var(--offset);
            }

        /* east-north & west-north */

        div.s8-tooltip[data-position$='-north']:after {
                top: var(--offset);
            }

        /* Styles --------------------------------------------------- */

        div.s8-tooltip.s8-light {

        border-color: rgba(255, 255, 255, 1);

        background-color: rgba(255, 255, 255, 1);

        --tw-text-opacity: 1;

        color: rgb(0 0 0 / var(--tw-text-opacity));
            box-shadow: 0px 2px 10px 0px rgba(39, 39, 17, 0.15);
}

        div.s8-tooltip.s8-light:after {

        border-color: rgba(255, 255, 255, 1);
                box-shadow: 0px 2px 10px 0px rgba(39, 39, 17, 0.15);
}

        div.s8-tooltip.s8-secondary {

        border-color: rgba(193, 122, 103, 1);

        background-color: rgba(193, 122, 103, 1);

        color: rgba(255, 255, 255, 1);
}

        div.s8-tooltip.s8-secondary:after {

        border-color: rgba(193, 122, 103, 1);
}</style>